import type { FareBreakdown as FareB } from '@raahi/shared';
import { formatPkr } from '@raahi/shared';

export function FareBreakdownView({ fare, paymentMethod }: { fare: FareB; paymentMethod?: string }) {
  return (
    <dl className="num grid grid-cols-2 gap-y-1 text-sm">
      <dt className="text-muted">Base fare</dt>
      <dd className="text-right font-medium">{formatPkr(fare.base)}</dd>
      <dt className="text-muted">Distance</dt>
      <dd className="text-right font-medium">{formatPkr(fare.distance)}</dd>
      <dt className="text-muted">Time</dt>
      <dd className="text-right font-medium">{formatPkr(fare.duration)}</dd>
      {fare.surge > 0 ? (
        <>
          <dt className="text-muted">Surge</dt>
          <dd className="text-right font-medium">+ {formatPkr(fare.surge)}</dd>
        </>
      ) : null}
      <dt className="border-t border-line pt-2 text-ink font-semibold">Total</dt>
      <dd className="border-t border-line pt-2 text-right font-display font-semibold">
        {formatPkr(fare.total)}
      </dd>
      {paymentMethod ? (
        <>
          <dt className="text-muted">Paid by</dt>
          <dd className="text-right font-medium capitalize">{paymentMethod}</dd>
        </>
      ) : null}
    </dl>
  );
}
